import { useState } from 'react';
import { getRealBash64Str, isImageFile } from '..';

const ACCEPT_FILE_TYPES = [
  '.doc',
  '.docx',
  '.pptx',
  '.ppt',
  '.xls',
  '.xlsx',
  '.jpg',
  '.jpeg',
  '.png',
  '.mp4',
  '.txt',
  '.pdf',
];
const IMAGE_COMPRESSSION_SUPPORT = {
  'image/jpeg': true,
  'image/png': true,
};
// 上传的文件最大10M
const UPOLOAD_FILE_MAX_SIZE = 10 * 1024 * 1024;

// 压缩图片 jpg or png only
const compressImage = (imgFile, type) => {
  if (IMAGE_COMPRESSSION_SUPPORT[imgFile.type] !== true) {
    return convertFile(imgFile);
  }

  let compressor = new window.ImageCompressor();

  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    const resultProcessor = (compressedSrc) => {
      resolve(compressedSrc);
    };
    reader.onload = (e) => {
      let imageSrc = reader.result;
      let image = new Image();
      image.src = e.target.result;

      image.onload = function () {
        const pxThreshold = 4096;
        let compressorSettings = {
          mimeType: imgFile.type,
          mode: 'strict',
          quality: 0.6,
          speed: 'low',
        };
        if (this.width > this.height) {
          compressorSettings.toWidth = Math.min(this.width, pxThreshold);
        } else {
          compressorSettings.toHeight = Math.min(this.height, pxThreshold);
        }
        compressor.run(imageSrc, compressorSettings, resultProcessor);
      };
    };
    reader.onerror = () => {
      reject(reader.error);
    };

    reader.readAsDataURL(imgFile);
  });
};

const convertFile = (file) => {
  if (IMAGE_COMPRESSSION_SUPPORT[file.type] === true) {
    return compressImage(file, file.type);
  }

  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.onerror = () => {
      reject(reader.error);
    };
    reader.readAsDataURL(file);
  });
};

const useUploadFile = () => {
  const [imgList, setImgList] = useState([]);
  const [fileList, setFileList] = useState([]);

  const selectFile = async (uploadFiles, setWarnFile, setAlertOpen, setFileTypeWarn, callback) => {
    if (uploadFiles && uploadFiles.length > 0) {
      let num = uploadFiles.length;
      for (let index = 0; index < num; index++) {
        // 获取文件的名称，大小，类型
        const currentFile = uploadFiles[index];
        const { name: fileName, size: fileSize, type: fileType } = currentFile;
        const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

        if (fileSize >= UPOLOAD_FILE_MAX_SIZE) {
          setWarnFile((prevState) => [...prevState, fileName]);
          setAlertOpen(true);
          continue;
        }
        if (!ACCEPT_FILE_TYPES.includes(`.${fileExtension}`)) {
          setFileTypeWarn((prevState) => [...prevState, fileName]);
          setAlertOpen(true);
          continue;
        }
        const result = await convertFile(currentFile);
        let tmpbase64 = getRealBash64Str(result);
        if (tmpbase64?.length > 0) {
          tmpbase64 = [tmpbase64];
        }
        const tmpfileType = fileType.split('/')[0].toUpperCase() === 'IMAGE' ? 'IMAGE' : 'FILE';
        const isImg = isImageFile(fileName);
        const previewUrl = isImg ? URL.createObjectURL(currentFile) : '';

        const fileObj = {
          name: fileName,
          base64: tmpbase64,
          previewUrl: previewUrl,
        };
        if (callback) {
          fileObj.id = await callback(tmpbase64[0], fileName, fileSize, tmpfileType, fileType);
        }
        isImg ? setImgList((prev) => [...prev, fileObj]) : setFileList((prev) => [...prev, fileObj]);
      }
    }
  };

  return {
    selectFile,
    imgList,
    setImgList,
    fileList,
    setFileList,
  };
};

export default useUploadFile;
export { ACCEPT_FILE_TYPES, convertFile };
